import { getLinkAriaLabel, getUrlText } from '@/utils/urlUtils';

import { AspectRatioImage } from '@/components/AspectRatioImage/AspectRatioImage';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import type { ContentfulMainMenuItemFragment } from '@/graphql/contentful/api';

import * as S from './Collections.styles';

export interface CollectionsProps {
  collections: ContentfulMainMenuItemFragment;
  setActiveSubmenu: (isActive: string) => void;
}

export const Collections = ({
  collections,
  setActiveSubmenu,
}: CollectionsProps) => {
  return (
    <S.Box data-test-id='CollectionsBox'>
      <S.DesktopMegamenu data-test-id='CollectionsDesktopMegamenu'>
        <S.Collections data-test-id='CollectionsCollections'>
          {collections?.submenuItemsCollection?.items?.map(
            (collection, index) => (
              <S.CollectionLink
                key={'collection' + collection?.internalName}
                aria-label={getLinkAriaLabel(getUrlText(collection?.url ?? ''))}
                data-test-id={`CollectionsCollection-${index}`}
                href={getUrlText(collection?.url ?? '')}
                onClick={() => setActiveSubmenu('')}
                target={collection?.openUrlInNewTab ? '_blank' : '_self'}
              >
                <S.CollectionItem
                  data-test-id={`CollectionsCollectionItem-${index}`}
                >
                  <AspectRatioImage
                    alt={`collection - ${collection?.image?.title}`}
                    aspectRatio={{
                      x: collection?.image?.width ?? 1,
                      y: collection?.image?.height ?? 1,
                    }}
                    className='image'
                    data-test-id={`CollectionsCollectionItemImage-${index}`}
                    focalPoint={{
                      x: (collection?.image?.width ?? 0) / 2,
                      y: (collection?.image?.height ?? 0) / 2,
                    }}
                    loaderProps={{ height: 175 }}
                    loading='lazy'
                    originalImageDimensions={{
                      x: collection?.image?.width ?? 0,
                      y: collection?.image?.height ?? 0,
                    }}
                    showFallbackPlaceholder
                    sizes='10vw'
                    src={collection?.image?.url ?? ''}
                    useLoader
                    width='100%'
                  />
                  <S.CollectionTitle
                    data-test-id={`CollectionsCollectionTitle-${index}`}
                  >
                    {collection?.label}
                  </S.CollectionTitle>
                </S.CollectionItem>
              </S.CollectionLink>
            ),
          )}
        </S.Collections>
        {collections?.bottomLinkLabel !== '' && (
          <S.LinkBox data-test-id='CollectionsLinkBox'>
            <LinkWithLocale
              aria-label={getLinkAriaLabel(collections?.bottomLinkUrl ?? '')}
              href={collections?.bottomLinkUrl ?? ''}
            >
              {collections?.bottomLinkLabel}
            </LinkWithLocale>
          </S.LinkBox>
        )}
      </S.DesktopMegamenu>
    </S.Box>
  );
};

Collections.displayName = 'Collections';
